import styled from 'styled-components';
import Button from 'material-ui/Button';

import { colors } from '../../../constants/styleConstants';

const SnackbarButton = styled(Button)`
  && {
    color: ${colors.principalOrange};
    font-size: ${props => props.fontSize};
  }

  span {
    color: ${colors.principalOrange};
  }
`;

SnackbarButton.defaultProps = {
  fontSize: '1.6em'
};

export default SnackbarButton;



// WEBPACK FOOTER //
// ./src/components/common/Snackbar/SnackbarButton.js